apigconfig = {

    'linkCard': {
        'method'       : 'POST',
        'endpointPath' : '/v1/secure/content'
    },

    'orderProduct': {
        'method'       : 'POST',
        'endpointPath' : '/v1/order/product'
    },

    'reservations': {
        'method'       : 'GET',
        'invokeUrl'    : 'https://devservice.payforward.com',
        'endpointPath' : '/v1/reservations/hotels'
    },

    'reservation': {
        'method'       : 'GET',
        'invokeUrl'    : 'https://devservice.payforward.com',
        'endpointPath' : '/v1/reservations/hotels'
    }

};
define("common/apigconfig", function(){});

